import React from 'react';
import PropTypes from 'prop-types';
import SMStream from '../streams/SMStream2';

const smWidgets = ({ tournamentId, teamId, seasonId }) => {
    return [
        {
            name: 'TeamSeasonFormSMWidget',
            props: {
                teamId,
                teamSide: 'both',
                ttIds: [tournamentId],
                seasonIds: [seasonId]
            }
        },
        {
            name: 'TeamSeasonWLMarginSMWidget',
            props: {
                teamId,
                typeLayout: 'center',
                ttIds: [tournamentId],
                seasonIds: [seasonId]
            }
        },
        {
            name: 'TeamSeasonH2HSMWidget',
            props: {
                teamId,
                typeStage: 'preMatch',
                ttIds: [tournamentId],
                seasonIds: [seasonId]
            }
        },
        {
            name: 'TeamSeasonAverageGoalsSMWidget',
            props: {
                teamId,
                ttIds: [tournamentId],
                seasonIds: [seasonId],
                typeTeam: 'both',
                typeStage: 'graphDot'
            }
        },
        {
            name: 'TeamSeasonTopScorersSMWidget',
            props: {
                teamId,
                incidentType: 'goals',
                activePlayers: true,
                layout: 2
            }
        }
    ];
};

function TeamSeasonStatsSMB({ params }) {
    return <SMStream smWidgets={smWidgets(params)} title="Team Stats" />;
}

TeamSeasonStatsSMB.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        teamId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired
    }).isRequired
};

export default TeamSeasonStatsSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TeamSeasonStatsSMB.js
 **/